import { Box, Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  paid: boolean
}

const BreakType = ({ paid }: Props) => {
  return (
    <Box width="fit-content">
      <Tag type={paid ? Tag.Types.lime : Tag.Types.malibu}>
        {paid
          ? i18n.t('company_settings.time.breaks.paid')
          : i18n.t('company_settings.time.breaks.unpaid')}
      </Tag>
    </Box>
  )
}

export default observer(BreakType)
